import type { Situazione } from '../api/tipi-dati.ts';

/**
 * Badge di una situazione.
 *
 * ⚠️ **Icona + etichetta, mai il solo colore.** È il vincolo di accessibilità
 * del progetto: distinguere "scaduta" da "in scadenza" è il motivo per cui
 * l'applicazione esiste, e circa un uomo su dodici non distingue rosso e
 * verde. Chi modifica questo componente non deve togliere né l'icona né il
 * testo per "renderlo più pulito".
 */

const aspetto: Record<Situazione, { classe: string; icona: string; etichetta: string }> = {
  SCADUTA: { classe: 'badge-scaduta', icona: '▲', etichetta: 'Scaduta' },
  IN_SCADENZA: { classe: 'badge-in-scadenza', icona: '◔', etichetta: 'In scadenza' },
  PIANIFICATA: { classe: 'badge-pianificata', icona: '▣', etichetta: 'Pianificata' },
  COMPLETATA: { classe: 'badge-completata', icona: '✓', etichetta: 'Completata' },
  ANNULLATA: { classe: 'badge-annullata', icona: '⊘', etichetta: 'Annullata' },
};

export function BadgeSituazione({ situazione }: { situazione: Situazione }) {
  const s = aspetto[situazione];
  return (
    <span className={`badge ${s.classe}`}>
      {/* L'icona è decorativa: l'etichetta accanto dice già tutto, e farla
          leggere due volte a un lettore di schermo sarebbe rumore. */}
      <span aria-hidden="true">{s.icona}</span>
      {s.etichetta}
    </span>
  );
}

/** Classe della riga di tabella, per la barretta colorata a sinistra. */
export function classeRiga(situazione: Situazione): string {
  switch (situazione) {
    case 'SCADUTA': return 'riga-scaduta';
    case 'IN_SCADENZA': return 'riga-in-scadenza';
    case 'PIANIFICATA': return 'riga-pianificata';
    case 'ANNULLATA': return 'riga-annullata';
    case 'COMPLETATA': return '';
  }
}
